import { render, staticRenderFns } from "./MorningstarAnalystTable.vue?vue&type=template&id=3b39b5ae&scoped=true"
import script from "./MorningstarAnalystTable.vue?vue&type=script&lang=ts"
export * from "./MorningstarAnalystTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b39b5ae",
  null
  
)

export default component.exports